<template>
		<div class="c-youtube-container">
			<iframe v-if="url" 
			:src="url"
			:title="title" 
			frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			allowfullscreen>
		</iframe>
	</div>
</template>

<script>
import { url } from 'video.js';


export default {
	name: "YouTubePlayer",
	props: {
		url: {
			type: String
		},
		title: {
			type: String
		}
	},
	mounted(){
		
	}
};
</script>
